import { render, staticRenderFns } from "./PayinTransDetails.vue?vue&type=template&id=6f5edc6d&scoped=true"
import script from "./PayinTransDetails.vue?vue&type=script&lang=js"
export * from "./PayinTransDetails.vue?vue&type=script&lang=js"
import style0 from "./PayinTransDetails.vue?vue&type=style&index=0&id=6f5edc6d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5edc6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f5edc6d')) {
      api.createRecord('6f5edc6d', component.options)
    } else {
      api.reload('6f5edc6d', component.options)
    }
    module.hot.accept("./PayinTransDetails.vue?vue&type=template&id=6f5edc6d&scoped=true", function () {
      api.rerender('6f5edc6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/PayinTransDetails.vue"
export default component.exports